import { is } from 'ramda';
import React, { ElementType, FC, MutableRefObject, Dispatch } from 'react';

import { sanitizeProps } from '../../../helpers/w3c';
import classNames, { ClassValue } from './classNames';

export type ElementTagProps = {
  as?: ElementType;
  className?: ClassValue;
  href?: string;
  innerRef?: MutableRefObject<HTMLElement | void | null> | Dispatch<any>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const getTag = (as?: ElementType, href?: string): ElementType => {
  if (as) {
    return as;
  }

  if (href) {
    return 'a';
  }

  return 'div';
};

const ElementTag: FC<ElementTagProps> = (props) => {
  const { as, href, children, className, innerRef, ...rest } = props;
  const Tag = getTag(as, href);
  const classes = classNames(className);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const refProps: any = {};
  if (innerRef) {
    if (is(String, Tag)) {
      refProps.ref = innerRef;
    } else {
      refProps.innerRef = innerRef;
    }
  }

  return (
    <Tag
      className={classes}
      href={href}
      {...refProps}
      {...sanitizeProps(Tag, [], rest)}
    >
      {children}
    </Tag>
  );
};

export default ElementTag;
